import React, { Component } from 'react';
import $ from 'jquery';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { s3StaticPath, getDemoVideoLink } from '../../helper/helperFunctions';
import { MdLocalMovies } from 'react-icons/md';
import { IoMdPlay } from 'react-icons/io';
import { FaHandHoldingHeart, FaQuestion } from 'react-icons/fa';


import VideoIcon from './VideoIcon'
import MainClients from './MainClients';
class KeepsakeVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
            activeTabNo: 1,
            activeVideo: 1,
            bucket: 'https://grouptravelvideos.s3.amazonaws.com/',
            videoUrl: 'global/2025_Washington_DC_demo.mp4',
            location: 'Washington DC'
        };
        this.handleHover = this.handleHover.bind(this);
        this.activeTabFunction = this.activeTabFunction.bind(this);
    }
    activeTabFunction(tab, name, url = null, location = null) {
        if (name === 'activeVideo') {
            if (this.state.activeVideo !== tab) {
                this.setState({ [name]: tab, videoUrl: url, location: location },);
            }
        } else {
            if (this.state.activeTabNo !== tab) {
                this.setState({ [name]: tab });
            }
        }
        return null;
    }

    handleVideo() {
        let demoVideo = document.getElementById("demoVideo");
        demoVideo.play();
    }
    handleHover() {
        // this.setState(prevState => ({
        //     isHovered: !prevState.isHovered
        // }));

        $("#clients div.client").hover(function () {
            $("#clients div.client").removeClass("pink_gradient")
            $(this).addClass("pink_gradient")
        }, function () {
            $("#clients div.client").removeClass("pink_gradient")
        })
    }

    render() {
        const videos = getDemoVideoLink(this.props.location.search);
        // const hoverClass = this.state.isHovered ? "client pink_gradient" : "client";
        // let sliderSettings = {
        //   dots: true,
        //   autoplay: true,
        //   infinite: true,
        //   speed: 500,
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        //   accessibility: false,
        //   className: 'benefits',
        //   prevArrow: <div><MdArrowBack /></div>,
        //   nextArrow: <div><MdArrowForward /></div>,
        // };
        const posters = {
            'Washington DC': 'washington-dc.jpg',
            'Chicago': 'Chicago.jpg',
            'New York City': 'New-York-City.jpg',
            'Orlando': 'Orlando.jpg',
            'Italy': 'Italy.jpg',
            'Memphis': 'Memphis.jpg',
            'Nashville': 'Nashville.jpg',
            'Nashville & Memphis': 'Nashville-Memphis.jpg',
            'St. Louis': 'St-Louis.jpg',
            'Performance Groups': 'Performance-Groups.jpg',
            'Tropical Adventures': 'Tropical-Adventures.jpg',
            'Mackinac Island': 'Mackinac-Island.jpg',
            'Ireland': 'Ireland.jpg',
            'Europe': 'Europe.jpg',
            'Alaska': 'Alaska.jpg',
            'New Orleans': 'New-Orleans.jpg',
        }

        let is_itk = false;

        if (window.location.href.indexOf("itk") > -1) {

            is_itk = true;
        } else {
            is_itk = false;
            console.log("else part run");
        }
        console.log("is_itk===>", is_itk);
        return (
            <React.Fragment>

                <section id="keepsake_video" className="section">
                    <h2 className="panel_heading">We create a storytelling video to keep for a lifetime!</h2>

                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 mt-xlg">
                                <div className=" mt-md">
                                    <img src={s3StaticPath('img/keepsake_video.png')} alt="Keepsake Storytelling Video" />
                                </div>
                            </div>
                            <div className="col-md-8 mt-xlg">
                                <div className="mt-md">
                                    <p className="text_24 text-center">
                                        We use the photos everyone shares on your trip and combine them with non-copyright music and titles you may customize.
                                    </p>
                                    <p className="text_24 mt-xxlg text-center">
                                        View and download the video with our app or on this website to enjoy for a lifetime.
                                    </p>
                                    <p className="text_24 mt-xxlg text-center">
                                        You can store it on any media of your choice: computer, flash drive, external hard drive, cloud, and/or phone. It is yours to keep and enjoy for years to come!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="uploaderTabs" className="section bg_alter sampleVideos">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="tabsContainer">
                                    <div className="tabsHeader">
                                        <div className="flexElem respFlex alignCenter">
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(1, 'activeTabNo')}

                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 1 ? "activeTab red_gradient" : "medium_blue_gradient")}><MdLocalMovies />&nbsp;Sample Videos</a>
                                            </div>
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(2, 'activeTabNo')}
                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 2 ? "activeTab red_gradient" : "medium_blue_gradient")}><FaQuestion />&nbsp;How it works</a>
                                            </div>
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(3, 'activeTabNo')}
                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 3 ? "activeTab red_gradient" : "medium_blue_gradient")} ><FaHandHoldingHeart />&nbsp;Benefits</a>
                                            </div>
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(4, 'activeTabNo')}
                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 4 ? "activeTab red_gradient" : "medium_blue_gradient")}><IoMdPlay />&nbsp;App Demo</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="tabsContent">
                                        {this.state.activeTabNo === 1 &&
                                            <div className="contentContainer">
                                                <div className="flexElem respFlex">
                                                    <div>
                                                        <div className="text_18 text-left">Student Travel</div>

                                                        <ul className="sampleVideosList">
                                                            <li onClick={() => this.activeTabFunction(1, 'activeVideo', 'global/2025_Washington_DC_demo.mp4', 'Washington DC')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 1 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 1 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Washington DC</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(2, 'activeVideo', 'global/2025_New_York_demo.mp4', 'New York City')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 2 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 2 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> New York City</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(3, 'activeVideo', 'global/2025_Orlando_demo.mp4', 'Orlando')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 3 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 3 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Orlando</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(4, 'activeVideo', 'global/2025_Chicago_demo.mp4', 'Chicago')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 4 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 4 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Chicago</span>
                                                            </li>
                                                            {/* <li onClick={() => this.activeTabFunction(5, 'activeVideo', 'global/2025_Nashville_And_Memphis_demo.mp4', 'Memphis')}>
                                <VideoIcon iconClass={this.state.activeVideo === 5 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 5 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                <span> Memphis</span>
                              </li> */}
                                                            <li onClick={() => this.activeTabFunction(6, 'activeVideo', 'global/2025_Nashville_And_Memphis_demo.mp4', 'Nashville & Memphis')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 6 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 6 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Nashville & Memphis</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(7, 'activeVideo', 'global/2025_St_Louis_demo.mp4', 'St. Louis')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 7 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 7 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> St. Louis</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(8, 'activeVideo', 'global/2025_New_Orleans_demo.mp4', 'New Orleans')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 8 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 8 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> New Orleans</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(9, 'activeVideo', 'global/2025_Performance_Groups_demo.mp4', 'Performance Groups')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 9 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 9 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Performance Groups </span>
                                                            </li>
                                                        </ul>

                                                        <div className="text_18 mt-xlg text-left">Adult Senior Travel</div>

                                                        <ul className="sampleVideosList">
                                                            <li onClick={() => this.activeTabFunction(10, 'activeVideo', 'global/2025_senior_italy_demo.mp4', 'Italy')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 10 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 10 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Italy</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(11, 'activeVideo', 'global/2025_senior_Alaska_demo.mp4', 'Alaska')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 11 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 11 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Alaska</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(12, 'activeVideo', 'global/2025_senior_Ireland_demo.mp4', 'Ireland')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 12 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 12 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Ireland</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(13, 'activeVideo', 'global/2025_senior_Europe_demo.mp4', 'Europe')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 13 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 13 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Europe</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(14, 'activeVideo', 'global/2025_senior_Mackinac_Island_demo.mp4', 'Mackinac Island')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 14 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 14 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Mackinac Island</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(15, 'activeVideo', 'global/2025_senior_Tropical_Adventures_demo.mp4', 'Tropical Adventures')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 15 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 15 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Tropical Adventures</span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div id="video" style={{ border: "none" }}>
                                                        <div className="vidContainer">
                                                            <div className="section_heading mt-none text-center">{this.state.location}</div>

                                                            <div className="video_placeholder mb-none">
                                                                <video onPlay={() => { $(".video_placeholder .video_play").hide() }} onPause={() => { $(".video_placeholder .video_play").show() }} id="demoVideo" controls src={this.state.bucket + this.state.videoUrl} type="video/mp4"
                                                                    poster={this.state.bucket + `static/img/${posters[this.state.location]}`}></video>
                                                                <div className="video_play blue_gradient hover_dark" onClick={this.handleVideo}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.activeTabNo === 2 &&
                                            <div className="contentContainer">
                                                <div className="flexElem">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">1</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            We provide your group with a Unique username & password login to access the app and website—making it easy to upload trip photos, stay connected, and enjoy all the app’s features.
                                                        </div>
                                                        <div className="text_14 mt-xs">
                                                            {/* We can also send you a camera or memory card. */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">2</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Everyone in your group can snap and share their favorite moments into one private gallery—bringing everyone’s memories together in one secure place.
                                                        </div>
                                                        <div className="text_14 mt-xs">
                                                            {/* You return any of our cameras or cards back in the prepaid mailer we provide. */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">3</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            We give your group’s shared memories the VIP treatment— removing duplicates or unwanted shots, then enhancing them with music, transitions, and effects. Once polished, your memories are reposted to your group's private gallery and transformed into a meaningful keepsake video.
                                                        </div>
                                                        {/* <div className="text_14 mt-xs">
                              Your photos can only be accessed with your group’s login.
                                    </div> */}
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">4</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            {/* We ship your DVDs to you and make your video available to stream on our app &amp; website. */}
                                                            Your final keepsake video is available to stream in the app and download via our website. Easily share it across social platforms or with family and friends. Plus, it serves as an impactful recruiting tool for showcasing the value of your future trips.

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.activeTabNo === 3 &&
                                            <div className="contentContainer">
                                                <div className="flexElem">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Real-Time Communication:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Built-in Messaging feature <small>(No Phone Numbers Required)</small>
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Group Leaders can send announcements to entire group or create sub groups
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Document uploader <small>(examples: itineraries, emergency contacts, room assignments, etc.)</small>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Traveler Location &amp; Safety Features:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Assists Group leaders by helping keep track of travelers <br /> <small>(with permissions enabled. Only during travel dates.)</small>
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Establish meeting points with your group
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Helps ensure everyone stays together and safe throughout the trip
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Shared Private Gallery:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Upload your photos and approved video clips
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                View and enjoy moments shared by other group members
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                All trip memories are stored in one private, secure gallery just for your group
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Professional Storytelling Keepsake Video:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Our editors enhance your shared photos with music, transitions, and effects
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Duplicates and low-quality shots are removed for a clean final product
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                The final keepsake video is available to stream in the app and download from the website
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Include your Performance Music & Live Video Clips in your Keepsake Video for Free!
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Download &amp; Share with Ease:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Download your keepsake video to save and watch anytime, on any device
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Share memories on social media or send directly to loved ones
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Great for celebrating the trip or to use as a recruiting tool for future trip participation
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Share the Journey With Loved Ones at Home:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Parents and Family can log into the app to see real-time photo uploads
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Feel included in the experience as memories are made
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Brings peace of mind and excitement to loved ones at home
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Boost Future Group Participation:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Use the Keepsake Video as a recruiting tool for future trips
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Inspire others by showcasing what makes your trips memorable
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Proven to help increase group sizes for future travel opportunities
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.activeTabNo === 4 &&
                                            <div className="row">
                                                {videos.map((video, index) => (
                                                    <div
                                                        key={index}
                                                        className={
                                                            videos.length > 1
                                                                ? "col-md-6 mt-lg text-center"
                                                                : "col-md-12 mt-lg text-center"
                                                        }
                                                    >
                                                        <div className="contentContainer">

                                                            {video.title && (
                                                                <h4 className="mb-md">{video.title} Demo</h4>
                                                            )}

                                                            <div className="video_placeholder mb-none">
                                                                <video
                                                                    id={`demoVideo_${index}`}
                                                                    controls
                                                                    src={video.src}
                                                                    poster={video.poster}
                                                                    onPlay={(e) => {
                                                                        $(e.target)
                                                                            .closest(".video_placeholder")
                                                                            .find(".video_play")
                                                                            .hide();
                                                                    }}
                                                                    onPause={(e) => {
                                                                        $(e.target)
                                                                            .closest(".video_placeholder")
                                                                            .find(".video_play")
                                                                            .show();
                                                                    }}
                                                                />

                                                                <div
                                                                    className="video_play blue_gradient hover_dark"
                                                                    onClick={() => {
                                                                        document
                                                                            .getElementById(`demoVideo_${index}`)
                                                                            .play();
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                        {/* {this.state.activeTabNo === 4 &&
                                            <div className="contentContainer">
                                                <div className="video_placeholder mb-none">
                                                    <video onPlay={() => { $(".video_placeholder .video_play").hide() }} onPause={() => { $(".video_placeholder .video_play").show() }} id="demoVideo" controls type="video/mp4" src={s3StaticPath('gtv_appDemo_apple.mp4')} poster={s3StaticPath('img/gtv_app_video.jpg')}>
                                                    </video>
                                                    <div className="video_play blue_gradient hover_dark" onClick={this.handleVideo}></div>
                                                </div>
                                            </div>
                                        } */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default KeepsakeVideo;
